import store from './store';

let languagePlugin = {
    waitLanguage() {
        if (this.store.state.language && !this.store.state.loaded) {
            return new Promise((resolve, reject) => {
                resolve(this.store.state.language);
            });
        } else {
            return this.loadingPromise;
        }
    },
    waitTranslations() {
        if (this.translationsLoadingPromise) {
            return this.translationsLoadingPromise;
        } else {
            return this.waitLanguage().then(() => {
                return this.store.dispatch('loadTranslations');
            });
        }
    },
    getLanguage() {
        return this.store.getters.getLanguage;
    },
    getLanguages() {
        return this.store.state.languages;
    },
    setLanguage(value) {
        this.store.commit('setLanguage', value);
    },
    translate(value) {
        // Usage:
        // <p>{{$language.translate('Language switcher')}}</p>
        // <p>{{'Language switcher' | translation}}</p>

        let result = value;
        if (Array.isArray(value)) {
            result = Object.assign({}, value);

            for (let key of Object.keys(value)) {
                let label = value[key];
                if(this.store.state.translations[label]){
                    result[key] = this.store.state.translations[label];
                }
            }
        }

        if(this.store.state.translations[value]){
            result = this.store.state.translations[value];
        } else {
            console.warn('Translation is missing:', value);
        }

        return result;
    },
    getAttributeByLanguage(attributes = {}, indexname) {
        const lang = this.getLanguage();
        if (attributes.hasOwnProperty(lang) && attributes[lang].hasOwnProperty(indexname)) {
            return attributes[lang][indexname];
        }
        return '';
    },
    loadingPromise: null,
};

export default {
    install(Vue) {
        languagePlugin.store = store;

        if (Vue.localStorage && Vue.localStorage.get('selectedLanguage')) {
            languagePlugin.store.commit('setLanguage', Vue.localStorage.get('selectedLanguage'));
        }

        languagePlugin.loadingPromise = store.dispatch('loadLanguages').then(() => {
            let selectedLanguage = '';

            let browserLanguage = navigator.language;
            browserLanguage = browserLanguage.substring(0, browserLanguage.indexOf('-'));

            if (
                Vue.localStorage &&
                Vue.localStorage.get('selectedLanguage') &&
                languagePlugin.store.state.languages[Vue.localStorage.get('selectedLanguage')]
            ) {
                selectedLanguage = Vue.localStorage.get('selectedLanguage');
            } else if (languagePlugin.store.state.languages[browserLanguage]) {
                selectedLanguage = browserLanguage;
            } else {
                Object.values(languagePlugin.store.state.languages).some(language => {
                    if (language.isDefault) {
                        selectedLanguage = language.lang;
                        return true;
                    }
                });
            }

            if (!selectedLanguage) {
                Object.values(languagePlugin.store.state.languages).some(language => {
                    selectedLanguage = language.lang;
                    return true;
                });
            }

            if (languagePlugin.store.state.language === null) {
                languagePlugin.store.commit('setLanguage', selectedLanguage);
            }
            return selectedLanguage;
        });

        Vue.filter('translation', languagePlugin.translate.bind(languagePlugin));

        Vue.$language = languagePlugin;
        Vue.prototype.$language = languagePlugin;
    },
};